<template>
    <p>
        <v-number-input @update:model-value="dataChanged" label="Maschio" v-model="properties.q_male" :min="0" :max="30" class="mb-6" />
        <v-number-input @update:model-value="dataChanged" label="Femmina" v-model="properties.q_female" :min="0" :max="30" class="mb-6" />
        <v-number-input @update:model-value="dataChanged" label="Giovane" v-model="properties.q_young" :min="0" :max="30" class="mb-6" />
        <v-number-input @update:model-value="dataChanged" label="Piccolo" v-model="properties.q_kid" :min="0" :max="30" class="mb-6" />
        <v-number-input @update:model-value="dataChanged" label="Indeterminato" v-model="properties.q_undefined" :min="0" :max="30" class="mb-6" />
        <!-- <v-text-field :readonly="true" :value="totalecontofauna" type="number" label="sola lettura" hide-details /> -->
    </p>
    <p class="text-title-large text-grey-darken-2 text-left my-1 mx-3">Totale {{ totalecontofauna  }}</p>
</template>

<script setup>

import { computed, onMounted, nextTick } from "vue"

const properties = defineModel("properties")

const totalecontofauna = computed(()=> {
    let tot = 0
    tot = tot + (properties?.value?.q_male || 0)
    tot = tot + (properties?.value?.q_female || 0)
    tot = tot + (properties?.value?.q_young || 0)
    tot = tot + (properties?.value?.q_kid || 0)
    tot = tot + (properties?.value?.q_undefined || 0)
    // console.log("totalecontofauna called") 
    // totalecontofauna.value = tot
    return tot
})

onMounted(() => {
    dataChanged()
})



const dataChanged = async () => {
    // await nextTick()
    // if (totalecontofauna.value == 0){
    //     properties.value.q_male = 1
    // }
}

</script>

<style scoped></style>
